import type { PersonProfilePresentationRow } from "./peopleManagerPresenter.js";

export function watchOrganizationPeople(input: {
  organizationId: string;
  load: (body: Record<string, unknown>) => Promise<Record<string, unknown>>;
  onChange: (people: Record<string, PersonProfilePresentationRow>) => void;
  onError: () => void;
  refreshMs?: number;
}): () => void {
  let stopped = false;
  let timer: ReturnType<typeof setTimeout> | undefined;
  const refresh = async (): Promise<void> => {
    try {
      const people: Record<string, PersonProfilePresentationRow> = {};
      let cursor: string | null = null;
      const seen = new Set<string>();
      do {
        const response = await input.load({
          organizationId: input.organizationId,
          ...(cursor ? { cursor } : {}),
        });
        if (stopped) return;
        if (response.organizationId !== input.organizationId || !Array.isArray(response.people))
          throw new Error("invalid_people_response");
        for (const row of response.people) {
          if (!row || typeof row.uid !== "string" || row.status !== "active") continue;
          people[row.uid] = {
            uid: row.uid,
            displayName: typeof row.displayName === "string" ? row.displayName : null,
            email: typeof row.email === "string" ? row.email : null,
            status: row.status,
            phoneNumber: null,
            photoUrl: null,
          };
        }
        cursor = typeof response.nextCursor === "string" ? response.nextCursor : null;
        if (cursor && seen.has(cursor)) throw new Error("repeated_people_cursor");
        if (cursor) seen.add(cursor);
      } while (cursor);
      if (!stopped) input.onChange(people);
    } catch {
      if (!stopped) {
        input.onChange({});
        input.onError();
      }
    }
    if (!stopped) timer = setTimeout(() => void refresh(), input.refreshMs ?? 30_000);
  };
  void refresh();
  return () => {
    stopped = true;
    clearTimeout(timer);
  };
}
